import AppRoutes from './routes/AppRoutes'; // นำเข้า AppRoutes
import React from "react";
import "./App.css";

const App = () => {
    return (
      <div>
        <AppRoutes />
      </div>
    );
  };

export default App;
